import React from "react";

const PageAvail = ({ stroke = "red", fill = "red", ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      {...props}
    >
      <g clipPath="url(#clip0_178_2799)">
        <path
          d="M5.82951 12.4766H2.49617C1.75979 12.4766 1.16284 11.8796 1.16284 11.1432V3.8099C1.16284 3.07352 1.7598 2.47656 2.49618 2.47656H13.1628C13.8992 2.47656 14.4962 3.07352 14.4962 3.8099V6.47656"
          stroke={stroke}
          strokeLinecap="round"
        />
        <path d="M1.16284 5.14453H14.4962" stroke={stroke} />
        <circle cx="11.4964" cy="11.4769" r="3.83333" stroke={stroke} />
        <path
          d="M9.82983 11.1432L11.1634 12.4767L13.4972 9.80957"
          stroke={stroke}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_178_2799">
          <rect
            width="16"
            height="16"
            fill={fill}
            transform="translate(0.49707)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default PageAvail;
